import axios from 'axios';
// config
import { HOST_API_KEY } from '../config-global';
import { configureUnauthorizedHandler } from './unauthorizedHandler';

// ----------------------------------------------------------------------

const axiosInstance = axios.create({ baseURL: HOST_API_KEY });
configureUnauthorizedHandler(axiosInstance);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject((error.response && error.response.data) || 'Something went wrong')
);

export default axiosInstance;
